import { HtmlParser } from '@calendly/html-parser';
import { I18n } from '@calendly/i18n';
import { IconBuildings } from '@calendly/ui/components/glyphs/IconBuildings';
import { Tooltip } from '@calendly/ui/components/tooltip';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorTextSecondary } from '@calendly/ui/theme';
import { zIndexNotification } from '@calendly/ui/z-index';
import { normalizeRecapAccessLevel, RECAP_ACCESS_LEVELS } from 'features/recaps/constants';
import { useRecapShare } from 'features/recaps/meeting_list/meeting_card/recap_share_context';
import { OrganizationPermissionSelect, PermissionSelectReadOnly, getRelationLabel } from './permission_select';
import { AccessListItem, AccessListItemAction, AccessListItemContent, AccessListItemText, accessListItemTextLineCss, OrganizationIconContainer, organizationListItemContentCss, permissionSelectReadOnlyLabelCss } from './styles';

// TooltipUI is inline-flex; wrap parsed HTML so <strong> is not a separate flex item.
const organizationHiddenTooltipTextCss = "o6rnv8s";
const getOrganizationHiddenTooltipText = () => <span className={organizationHiddenTooltipTextCss}>
    {HtmlParser(I18n.t('publisher.meeting_recap.share_modal.access_list.organization_hidden_tooltip_html', {
    only_me: I18n.t('publisher.meeting_recap.share_modal.access_level.private.title')
  }))}
  </span>;
export const OrganizationAccessListItem = () => {
  const {
    accessLevel: {
      value: accessLevel
    },
    accessList: {
      organization,
      owner
    },
    currentUser,
    permissionUpdates: {
      getOrganizationRelation,
      setPendingOrgPermission
    }
  } = useRecapShare();
  const normalizedAccessLevel = normalizeRecapAccessLevel(accessLevel);
  const isRestricted = normalizedAccessLevel === RECAP_ACCESS_LEVELS.RESTRICTED;
  const isOwner = currentUser?.uuid === owner?.uuid;
  const organizationRelation = getOrganizationRelation(organization?.relation ?? null);
  const renderAction = () => {
    if (!isRestricted) {
      const hiddenLabel = I18n.t('publisher.meeting_recap.share_modal.access_list.permission_select.hidden');
      if (normalizedAccessLevel === RECAP_ACCESS_LEVELS.PRIVATE) {
        return <Tooltip text={getOrganizationHiddenTooltipText()} width="large" zIndex={zIndexNotification}>
            <AccessListItemAction data-testid="access-list-organization-permission">
              <LabelText size="large" color={colorTextSecondary} className={permissionSelectReadOnlyLabelCss}>
                {hiddenLabel}
              </LabelText>
            </AccessListItemAction>
          </Tooltip>;
      }
      return <PermissionSelectReadOnly label={hiddenLabel} testId="access-list-organization-permission" />;
    }

    // Non-owners cannot edit organization permission, show read-only view
    if (!isOwner) {
      const label = organizationRelation ? getRelationLabel(organizationRelation) : I18n.t('publisher.meeting_recap.share_modal.access_list.permission_select.hidden');
      return <PermissionSelectReadOnly label={label} testId="access-list-organization-permission-readonly" />;
    }
    return <OrganizationPermissionSelect value={organizationRelation} onChange={setPendingOrgPermission} onRemove={() => setPendingOrgPermission(null)} />;
  };
  return <AccessListItem data-testid="access-list-organization">
      <AccessListItemContent className={organizationListItemContentCss}>
        <OrganizationIconContainer>
          <UiIcon icon={IconBuildings} size="medium" title="" />
        </OrganizationIconContainer>
        <AccessListItemText>
          <BodyText className={accessListItemTextLineCss}>
            {I18n.t('publisher.meeting_recap.share_modal.access_list.general_access.organization')}
          </BodyText>
        </AccessListItemText>
      </AccessListItemContent>
      {renderAction()}
    </AccessListItem>;
};

require("./organization_access_list_item.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./organization_access_list_item.js");